// extracted by mini-css-extract-plugin
export default {"card":"Settings_card__RFOeA","inner-container":"Settings_inner-container__H8HI4","section":"Settings_section__oVz8b"};